module.exports = __webpack_public_path__ + "static/img/15056B_3_4_C_20210111_LC.211dcfd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/15056B_3_4_C_20210111_LC.png
// module id = k6so
// module chunks = 0